import { queryClient } from 'Providers/TanstackQueryProvider';
import { LiftStatusStorage, LOCAL_STORAGE_KEYS } from 'Utils/Storage';
import { $api } from '~/lib/api-client';

// Ends the server-side session.
//
// Goes through $api so it carries BOTH credentials: authMiddleware adds the
// bearer header and the client sends the session cookie. The route is guarded
// session-or-JWT, and on the web.app hosts — cross-site to the API, so the
// SameSite=Lax cookie never arrives — the token is the only credential there is.
//
// Fire and forget: the local logout must not wait on the network. The catch also
// covers an API that does not have the route yet (404) and a session that is
// already dead (401).
const endServerSession = () => {
  void $api['/liftstatus/auth/logout'].POST().catch(() => undefined);
};

export const logout = () => {
  endServerSession();

  localStorage.removeItem(LiftStatusStorage.storeKeyliftstatusOrganisation);
  localStorage.removeItem(LiftStatusStorage.storageKeyStartDate);
  localStorage.removeItem(LiftStatusStorage.storeKeyEndDate);
  localStorage.removeItem(LiftStatusStorage.storeKeyPeriod);

  for (const key of Object.values(LOCAL_STORAGE_KEYS)) {
    localStorage.removeItem(key);
  }

  queryClient.clear();
};
